import script from "./CustomFieldsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldsPage.vue?vue&type=script&setup=true&lang=js"

import "./CustomFieldsPage.vue?vue&type=style&index=0&id=ebaedc54&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebaedc54"]])

export default __exports__